import $ from "jquery";

export default function () {
  if ($("#handwritingFont").length === 0) {
    $("head").append(
      '<link id="handwritingFont" href="//fonts.googleapis.com/css?family=Coming+Soon:400,600" ' +
        'rel="stylesheet" type="text/css">'
    );
  }
}
